import { MenuList } from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import app from "../../../application/App";
import MenuItemComponent from "./menu/MenuItemComponent";
import { Menu } from "src/pi/application/Menu";

interface IProps {}

const TopMenuComponent: React.FC<IProps> = (props) => {
  const appStore = React.useMemo(() => app(), []);
  const pageMenu = React.useMemo(() => {
    return appStore?.pageMenu?.items != null
      ? new Menu({
          ...appStore.pageMenu,
          label: appStore.page?.label ?? appStore.page?.name ?? "Page",
        })
      : null;
  }, [appStore?.pageMenu]);

  if (!appStore.menu || appStore.menu.items.length < 1) return <div />;

  const hasIcon = appStore.menu.items?.filter((x) => x.icon != null).length > 0;

  return (
    <MenuList>
      {pageMenu != null && (
        <MenuItemComponent key="pageMenu" item={pageMenu} showIcon={false} />
      )}

      {appStore.menu.items.map((item, i) => (
        <MenuItemComponent
          key={`${i}-${item.label}`}
          item={item}
          showIcon={hasIcon}
        />
      ))}
    </MenuList>
  );
};

export default observer(TopMenuComponent);
